import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { TaxonomyListView } from 'src/app/general/taxonomies/list/taxonomy-list.view';
import { TaxonomyListDataService } from 'src/app/general/taxonomies/list/taxonomy-list.data';
import { UserTaskSummariesDataService } from 'src/app/general/user-tasks/list/user-task-list.data';
import { UserTasksListView } from 'src/app/general/user-tasks/list/user-tasks.list.view';
import { FormatService } from 'src/core/services/format.service';
import { ContextService } from 'src/core/services/context.service';
import { Button } from 'antd';
import { CommunicationService } from 'src/core/services/communication.service';

interface Props {
	modelType?: string;
	modelId?: number;
	onEdit: (id: number) => void;
	setBusy(isBusy: boolean);
	kanban?: boolean;
	useLoginFilter: boolean
	extraFilter?: (dataService: UserTaskSummariesDataService) => void;
	onLoad?: (data: UserTaskSummary[]) => void;
}

interface State {
	filters: {
		[key in keyof UserTaskSummary]?: { filter: string, value: any }
	};
}
@observer
export class UserTasksListController extends React.Component<Props, State> {
	@resolve
	private dialogService: DialogService;

	@resolve
	contextService: ContextService;

	@resolve
	formatService: FormatService;

	@resolve
	private toast: ToastNotifications;
	

	@resolve
	communicationService: CommunicationService;


	@observable
	dataService: UserTaskSummariesDataService;



	constructor(props: Readonly<Props>) {
		super(props);

		this.state = {
			filters: {}
		}
	}

	

	public componentWillUnmount() {
		this.communicationService.EventEmitter.removeListener("entityChange", this.onEntityChange.bind(this));
	}

	onEntityChange = async (data: EntityChange) => {
		if (data.TypeName == 'UserTask') {

			const id = data.EntityId[0];

			if (!!this.dataService.items.find(i => i.id === id)) {

				var tmp = UserTaskSummariesDataService.make(this.contextService, this.formatService);
				tmp.addFilter('id', 'eq', id);
				tmp.addSorting('id', 'asc');
				tmp.params = {};
				tmp.params["useLoginFilter"] = this.props.useLoginFilter;
				await tmp.load(query => query);

				if (tmp.item) {
					var index = this.dataService.items.findIndex(i => i.id == id);

					if (index > -1) {
						this.dataService.items[index] = tmp.item;
					}
				}
			}
			else if (data.Operation == 0) {
				this.loadData();
			}
		}
	}

	componentDidMount() {
		this.props.setBusy(true);

		this.communicationService.EventEmitter.on("entityChange", this.onEntityChange.bind(this));

		this.loadData()
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false);
			});
	}

	public reload = () => {
		this.loadData();
	}

	private async loadData(extraFilter?: any): Promise<void> {
		this.dataService = UserTaskSummariesDataService.make(this.contextService, this.formatService);

		this.dataService.addSorting('priority', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);

		if (this.props.modelType && this.props.modelId) {
			this.dataService.addFilter('modelType', 'eq', this.props.modelType)
			this.dataService.addFilter('modelId', 'eq', this.props.modelId)
		}
		if (this.props.extraFilter)
			this.props.extraFilter(this.dataService)

		for (var f in this.state.filters) {
			const filter = this.state.filters[f];
			this.dataService.addFilter(f as keyof UserTaskSummary, filter.filter, filter.value);
		}
		this.dataService.pageSize = 255;
		this.dataService.params = {};
		this.dataService.params["useLoginFilter"] = this.props.useLoginFilter;
		await this.dataService.load(query => query);
		if (this.props.onLoad)
			this.props.onLoad(this.dataService.items);
	}

	onFilterChange = (key: keyof UserTaskSummary, value: any, filter: any) => {
		if (value != null)
			this.setState({ filters: { ...this.state.filters, [key]: { filter, value } } }, this.reload);
		else {
			var filters = this.state.filters;
			delete filters[key as keyof UserTaskSummary];
			this.setState({ filters }, this.reload);
		}
	}

	handleItemDoubleClick = (item: UserTaskSummary): void => {
		this.props.onEdit(item.id);
	};

	onRemove = (item: UserTaskSummary) => {

		this.dialogService.showYesNo('Delete element', 'Are you sure?')
			.then((dialogResult) => {
				if (dialogResult) {

					if (item) {
						this.dataService.delete([item])
							.then(() => {
								this.reload();
							})
							.catch(error => this.toast.showToast('Delete failed!', ObjectUtils.parseError(error), 'error'));

					}
				}
			});
	}

	render() {
		if (this.dataService == null) {
			return null;
		}

		return (
			<UserTasksListView
				useAssignedToFilter={!this.props.useLoginFilter}
				kanban={this.props.kanban}
				model={this.dataService}
				setBusy={this.props.setBusy}
				onRemove={this.onRemove}
				reload={this.reload}
				onFilterChange={this.onFilterChange}
				onItemDoubleClick={this.handleItemDoubleClick}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/user-tasks/list/user-tasks.list.controller.tsx